export default class ClientBusinessErrorException extends Error {
    constructor(message){
        super(message)
        this.name = this.constructor.name
    }
}